"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WEB_MESSENGER_LABEL = exports.WEB_MESSENGER_BUTTON = void 0;
const WEB_MESSENGER_BUTTON = exports.WEB_MESSENGER_BUTTON = 'web-messenger-button';
const WEB_MESSENGER_LABEL = exports.WEB_MESSENGER_LABEL = 'web-messenger-label';
